export default {
    pxToRem(px){
        return px / parseFloat(getComputedStyle(document.documentElement).fontSize);
    },
    remToPx(rem){
        return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
    },
}
